import _, { escapeRegExp } from 'lodash'
import { setLocales, getLocales, getLocale, setLocale, loadLocale } from './locale'
import { observeIO, unobserveIO } from './intersectionObserver'
import breadcrumbsButtons from './breadcrumbsButtons'
import TyanDate from './Date'
import wsWithToken from './wsWithToken'
// 应用定义的locales，用于getLocal之前调用setLocales来设置appLocales
import locales from 'tyan/pubConfig/locales'

// 注册syncfusion
import { registerLicense } from '@syncfusion/ej2-base'
registerLicense('ORg4AjUWIQA/Gnt2UFhhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5QdEBjWH1Xc3FTQGdU')	// 25.x.x

if (!window.Tyan) {
	const tyanInit = () => {
		var isReady = false
		const readyTasks = []

		const ready = () => {
			// 检查appSettings是否已经装载完成
			if (!Tyan.appSettings.inited) {
				setTimeout(ready, 10)
				return
			}

			Ext.merge(Tyan.psnCfg, JSON.parse(localStorage.getItem('psnCfg')) || {}) // 读取当前前台配置

			// 本地化处理
			setLocales(locales)
			loadLocale().then(() => {
				isReady = true
				var task = undefined
				while (task = readyTasks.shift())
					task()
			})
		}

		window.Tyan = {
			Date: TyanDate,
			wsWithToken,
			onReady: (fn) => {
				if (typeof fn != 'function') return
				isReady ? fn() : readyTasks.push(fn)
			},
			// 各应用系统可以设置的一些配置，一般写在src/index.js的onReady中如
			// Tyan.onReady(() => {
			// 	Tyan.menus.version = 2
			// 	require('./menus')
			// 	start({ App, title: 'QMM实验室信息管理系统3.0', systemName: "LIMS3.0 - QMM实验室信息管理系统", companyName: "博世汽车柴油系统有限公司" })
			// })
			// 可用内容见帮助文档《ExtR 全局变量 Tyan 使用说明》
			// 因兼容而未纳入的参数还有：
			// 1、Tyan.sysMode
			// 2、Tyan.menus.version
			// 3、Tyan.mainPageProps
			sysConfig: {
				files: {
					unacceptableFiles: ['.svg', '.svg+xml', '.html', '.cmd', '.bat', '.exe'],		// 不可上传文件后缀
					maxSize: Infinity,
					fidKey: undefined
				},
				mainPage: {
					logo: undefined,					// 用于在主菜单按钮后呈现logo, 为 logo 资源 如 resources/logo.png
					noMenu: undefined,				// 不显示顶部菜单
				},
				menuWidth: 260
			},
			// public系统控制使用，由public使用，各应用请勿修改其中内容
			// 1、
			pubControl: {
				lastPostEvent: Date.now(),		// 由postEvent在向后端发起交易前更新
			},
			/**
			*  Tyan.sysMode: 
			*    public: 全开放，无登录功能，显示public, notLogin菜单项
			*    private: 不开放，必须登录，默认模式
			*    mixed: 混合，未登录状况，显示public, notLogin菜单项；登录后，根据权限处理，不显示notLogin菜单项。
			*		 sample: 演示、原型模式. 显示所有菜单
			*		 Tyan.menus.version > 5 则只有 sample有效，其它皆由loginInfo中的mode来确定
			*/
			sysMode: 'private',
			mainPageProps: {},
			appSettings: { inited: false, getMockData: null, config: {} }, // 将由public/index.js覆盖
			/**
			 * 
			 */
			menus: {
				/**
				 * version:
				 * 1:权限保存的是allMenu中的key, 
				 * 2：权限保存的是allMenu中的_path, 
				 * 5: 无allRoles, allTasks, allMenu, allPaths由loginInfo中的menu来设置, 
				 */
				version: 0,
				allMenu: {},
				allRoles: {},
				allTasks: {},
				pageRoutes: [],
				allPaths: {},
				hasOper: oper => {
					const { menus: { allPaths }, history: { location: { pathname } } } = Tyan
					return !!(oper && allPaths[pathname] && allPaths[pathname].opers && allPaths[pathname].opers.includes(oper))
				}
			},

			locationControl: {
				target: null,
				forms: [],
				handleHashChange: (e) => {
					Tyan.locationControl.hashChangeHandler && Tyan.locationControl.hashChangeHandler(e)
				},
				hashChangeHandler: null,      /* 由Layout在componentDidMount赋值，并在componentWillUnmount时置空 */
			},
			psnCfg: {						// 保存于localStorage
				numPerPage: 18,		// Manager页面每页记录数
				// locale: 'zh_CN',			// 本地化语言代码，由getLocale处理
			},
			// locales: undefined,	// 本地化信息，为空不做任何处理，不为空则结构为{}
			t: v => v, 		// 翻译函数，zh_CN不调用此函数，其它则覆盖该函数, 见locale/localization.js
			setPsnCfg: o => (Ext.merge(Tyan.psnCfg, _.cloneDeep(o)), localStorage.setItem('psnCfg', JSON.stringify(Tyan.psnCfg))),
			setLocales: (...args) => { throw 'Tyan.setLocales 已过期，请将参数内容置于src/pubConfig/locales.js中' },
			getLocales,
			setLocale,
			getLocale,
			fetchBegin: () => { },
			fetchEnd: () => { },
			forms: {},
			loginInfo: {},
			breadcrumbsButtons,
			emptyFn: () => { },
			observeIO,
			unobserveIO
		}

		window.addEventListener('hashchange', Tyan.locationControl.handleHashChange)

		!String.prototype.hashCode && (String.prototype.hashCode = function () {
			var hash = 0
			if (this.length == 0) return hash
			for (var i = 0; i < this.length; i++) {
				var char = this.charCodeAt(i)
				hash = ((hash << 5) - hash) + char
				hash = hash & hash // Convert to 32bit integer
			}
			return hash
		})

		!String.prototype.replaceAll && (String.prototype.replaceAll = function (s1, s2) {
			return this.replace(new RegExp(escapeRegExp(s1), "gm"), s2)
		})

		const promises = []

		/* webpackChunkName: "chunks/public/tyanext" */
		promises.push(import('core-js/actual/promise'))
		promises.push(import('../menus').then(m => { Tyan.setMenus = m.setMenus; return }))
		promises.push(import('./pubForm').then(m => { Tyan.pubForm = m.default; return }))
		promises.push(import('../utility').then(m => { Tyan.utility = m; return }))
		promises.push(import('./postErr').then(m => { Tyan.postErr = m.default; return }))
		promises.push(import('./doNexTime').then(m => { Tyan.doNextTime = m.default; return }))
		promises.push(import('./checkForm').then(m => { Tyan.checkForm = m.default; return }))
		promises.push(import('./format').then(m => { Tyan.format = m.default; return }))
		promises.push(import('./ej2monitor').then(m => { Tyan.addEj2Monitor = m.default; return }))
		promises.push(import('./clipboard').then(m => { Tyan.clipboard = m; return }))
		promises.push(import('./menuComponents').then(m => { Tyan.menuComponents = m.default; return }))
		promises.push(import('./sanitize').then(m => { Tyan.sanitize = m.default; return }))
		promises.push(import('./rmCtrlChar').then(m => { Tyan.rmCtrlChar = m.default; return }))
		promises.push(import('./printer').then(m => { Tyan.printer = m; return }))
		promises.push(import('../components/ViewFile').then(m => { Tyan.viewFile = m.viewFile; return }))
		Promise.all(promises).then(ready)
	}

	tyanInit()
}